import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const Navbar = () => {
  const Logo = '/favicon.png';

  return (
    <nav className="navbar">
      <div className="logo-container">
        <img src={Logo} alt="AFFEERCE Logo" className="logo-img" />
      </div>
      <div className="nav-links">
        <Link to="/">Home</Link>
        <Link to="/handbook">Handbook</Link>
        <Link to="/users">For Users and Investors</Link>
        <Link to="/blog">Blog</Link>

        <a 
          href="https://vipenv20240312084853.azurewebsites.net" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="toolkit-button"
        >
          Elsie Toolkit
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
